var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderOfPage',{attrs:{"bgSrc":'shopping.jpg',"titleOfPage":'التسويق والترفيه',"theDiscription":'تسويق وترفيه'}}),_c('section',{staticClass:"pages-container"},[_c('ShoppingContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }